<template>
  <div class="linear-progress">
      <div class="bar">
        <div class="progress" :style="{ width: `${value}%`, background: color }"/>
      </div>
    <span class="ml-2" :style="`font-size: ${ textSize }px;`">{{ value }}</span>
  </div>
</template>

<script>
import { getColorByValue } from "@/utils";

export default {
  name: "Linear",
  props: {
    value: {
      type: [ Number, String ],
      default: 80,
    },
    textSize: {
      type: [ Number, String ],
      default: 28,
    },
  },
  computed: {
    color() {
      return getColorByValue(this.value);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/style/responsive";

.linear-progress {
  display: flex;
  align-items: center;

  .bar {
    position: relative;
    height: 14px;
    width: 172px;
    max-width: 90%;
    background: #ECE7E4;
    overflow: hidden;
    border-radius: 5px;
  }
  .progress {
    position: absolute;
    display: block;
    left: 0;
    top: 0;
    height: 100%;
  }
  span {
    color: #282421;
    font-family: "Sofia Pro";
    font-size: 28px;
    font-weight: bold;
    text-align: right;
    width: 48px;

    @include mobile {
      width: 30px;
    }
  }
}
</style>